"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSpoofedDma = exports.selectSpoofedCurrentPostal = exports.selectSpoofedCountry = exports.withoutSpoofInfo = exports.applySpoofInfo = void 0;

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var applySpoofInfo = function applySpoofInfo(spoofInfo) {
  return function (state) {
    return _objectSpread({}, state, {
      spoofInfo: spoofInfo
    });
  };
};

exports.applySpoofInfo = applySpoofInfo;
var withoutSpoofInfo = (0, _utils.withoutKey)('spoofInfo');
exports.withoutSpoofInfo = withoutSpoofInfo;

var selectSpoofedCountry = function selectSpoofedCountry(state) {
  return state.spoofInfo && state.spoofInfo.countryCode;
};

exports.selectSpoofedCountry = selectSpoofedCountry;

var selectSpoofedCurrentPostal = function selectSpoofedCurrentPostal(state) {
  return state.spoofInfo && state.spoofInfo.postalCode;
};

exports.selectSpoofedCurrentPostal = selectSpoofedCurrentPostal;

var selectSpoofedDma = function selectSpoofedDma(state) {
  return state.spoofInfo && state.spoofInfo.dma;
};

exports.selectSpoofedDma = selectSpoofedDma;